import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import MediumEditor from 'medium-editor';
  import { onMounted, ref, watch, onBeforeUnmount } from 'vue';
  import 'medium-editor/dist/css/medium-editor.css';
  import 'medium-editor/dist/css/themes/tim.css';
  import ColorPickerExtension from './color-picker';

  export interface IProps {
    content?: string;
    options?: MediumEditor.CoreOptions;
  }
  export interface IEmits {
    (event: 'change', content: string): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    content: null,
    options: null
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'change', content: string): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    content?: string;
    options?: MediumEditor.CoreOptions;
  }

  
  

  let editor: MediumEditor.MediumEditor;
  const root = ref();

  let unwatch: ReturnType<typeof watch>;

  onBeforeUnmount(() => {
    unwatch && unwatch();
  });

  onMounted(() => {
    // https://github.com/yabwe/medium-editor
    editor = new MediumEditor(root.value, {
      disableEditing: false,
      spellcheck: false,
      targetBlank: true,
      toolbar: {
        buttons: ['bold', 'italic', 'underline', 'anchor', 'justifyLeft', 'justifyRight', 'justifyCenter', 'h2', 'h3', 'h4', 'colorPicker'],
      },
      placeholder: {
        text: 'Type your text',
        hideOnClick: true
      },
      imageDragging: false,
      ...props.options,
      extensions: {
        'colorPicker': new ColorPickerExtension()
      }
    });
    editor.setContent(props.content || '');
    editor.on(root.value, 'input', () => {
      emits('change', editor.getContent());
    }, false);

    // 可能外面直接修改了content
    unwatch = watch(
      () => props.content,
      (newVal = '') => {
        if (newVal !== editor.getContent()) {
          editor.setContent(newVal || '');
        }
      },
    );
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "editor"
  }, null, 512))
}
}

})